(function () {
  function initTrustBadges(root) {
    var track = root.querySelector('[data-tb-track]');
    var dotsEl = root.querySelector('[data-tb-dots]');
    if (!track || !dotsEl) return;

    var cards = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.classList.contains('tb-card');
    });
    if (cards.length < 2) return;

    function buildDots() {
      dotsEl.innerHTML = '';
      cards.forEach(function (_, i) {
        var d = document.createElement('div');
        d.className = 'tb-dot' + (i === 0 ? ' tb-dot-active' : '');
        dotsEl.appendChild(d);
      });
    }
    buildDots();
    var dots = Array.prototype.slice.call(dotsEl.children);

    function cardStep() {
      return cards[0].getBoundingClientRect().width;
    }

    function updateDots() {
      var idx = Math.round(track.scrollLeft / cardStep());
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      dots.forEach(function (d, i) {
        d.classList.toggle('tb-dot-active', i === idx);
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateDots);
    });
    window.addEventListener('resize', buildDots);
  }

  function initAll() {
    document.querySelectorAll('.tb-section').forEach(initTrustBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector('.tb-section');
    if (section) initTrustBadges(section);
  });
})();
